module.exports = __webpack_public_path__ + "static/media/default-water-meter.0960e216.png";